import type { ComponentType, ReactNode } from "react";
import {
  createToaster,
  HStack,
  Portal,
  Stack,
  Toast,
  Toaster as ChakraToaster,
  type CreateToasterReturn,
} from "@chakra-ui/react";

export const toaster = createToaster({
  placement: "top-end",
  pauseOnPageIdle: true,
  offsets: { top: "1rem", right: "1rem" },
});


type ToasterWithRenderChildren = {
  toaster: CreateToasterReturn;
  children: (toast: {
    title?: ReactNode;
    description?: ReactNode;
  }) => ReactNode;

  insetInline?: string | { mdDown?: string };
};

const ChakraToasterWithRender = ChakraToaster as ComponentType<ToasterWithRenderChildren>;

export function Toaster() {
  return (
    <Portal>
      <ChakraToasterWithRender toaster={toaster} insetInline="4">
        {(toast) => (
          <Toast.Root width={{ md: "sm" }} maxW="calc(100vw - 2rem)">
            <HStack alignItems="flex-start" gap="3" width="full">
              <Stack flex="1" gap="1" minW="0">
                {toast.title != null && (
                  <Toast.Title>{toast.title}</Toast.Title>
                )}
                {toast.description != null && (
                  <Toast.Description>{toast.description}</Toast.Description>
                )}
              </Stack>
              <Toast.CloseTrigger />
            </HStack>
          </Toast.Root>
        )}
      </ChakraToasterWithRender>
    </Portal>
  );
}
